import { render, staticRenderFns } from "./PcNewsCenter4.vue?vue&type=template&id=03da6afc&scoped=true&"
import script from "./PcNewsCenter4.vue?vue&type=script&lang=js&"
export * from "./PcNewsCenter4.vue?vue&type=script&lang=js&"
import style0 from "./PcNewsCenter4.vue?vue&type=style&index=0&id=03da6afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da6afc",
  null
  
)

export default component.exports